"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SyntheticNetworkQualitySDK = exports.MeasurementMode = void 0;
const rxjs_1 = require("rxjs");
const RxOp = __importStar(require("rxjs/operators"));
const openapi_1 = require("../../../generated/openapi");
const networkQuality_1 = require("../networkQuality");
const R = __importStar(require("ramda"));
const immer_1 = require("immer");
const NQError_1 = require("../NQError");
const NQValue_1 = require("../NQValue");
const convertToNQError_1 = require("../util/convertToNQError");
var MeasurementMode;
(function (MeasurementMode) {
    MeasurementMode["Production"] = "Production";
    // The flag cpuBenchmark set to 'false'
    MeasurementMode["Disabled_Benchmarks"] = "Disabled_Benchmarks";
    // Customer, download results are not satisfactory, modem test successfully run  
    MeasurementMode["Customer_NonSat_ModemAvailable"] = "Customer_NonSat_ModemAvailable";
    // Customer, download results are not satisfactory, modem test successfully run, provisionedDownloadSpeed < modem speed
    MeasurementMode["Customer_NonSat_ModemAvailable_SpeedLimit"] = "Customer_NonSat_ModemAvailable_SpeedLimit";
    // Customer, download results are not satisfactory, modem test successfully run, modem exchange message with a swap link was sent
    MeasurementMode["Customer_NonSat_ModemAvailable_SwapLink"] = "Customer_NonSat_ModemAvailable_SwapLink";
    // Customer, download results are not satisfactory, modem test did not run due to DCA
    MeasurementMode["Customer_NonSat_ModemNotAvailableDCA"] = "Customer_NonSat_ModemNotAvailableDCA";
    // Customer, download results are not satisfactory, modem test failed
    MeasurementMode["Customer_NonSat_ModemFailed"] = "Customer_NonSat_ModemFailed";
    // Customer, download results are satisfactory, modem test was not needed
    MeasurementMode["Customer_Sat"] = "Customer_Sat";
    // Customer, download results are satisfactory, modem test was not needed, modem exchange message with a swap link was sent
    MeasurementMode["Customer_Sat_SwapLink"] = "Customer_Sat_SwapLink";
    // Non-customer, no vpn detected
    MeasurementMode["NonCustomer_NoVpn"] = "NonCustomer_NoVpn";
    // Non-customer, vpn detected
    MeasurementMode["NonCustomer_Vpn"] = "NonCustomer_Vpn";
    // Non instant prepare step
    MeasurementMode["Wait_For_Prepare"] = "Wait_For_Prepare";
    // No network connectivity
    MeasurementMode["Error_Unconnected"] = "Error_Unconnected";
    // On top of NonCustomer_NoVpn scenario, an error happens during upload stage
    MeasurementMode["Error_During_Upload_NonCustomer_NoVpn"] = "Error_During_Upload_NonCustomer_NoVpn";
    // On top of Customer_NonSat_ModemAvailable, an error happens during modem stage
    MeasurementMode["Error_On_Modem_Customer_NonSat_ModemAvailable"] = "Error_On_Modem_Customer_NonSat_ModemAvailable";
    // When parallel tests are detected by the server
    MeasurementMode["Error_Parallel_Speedtests"] = "Error_Parallel_Speedtests";
    // When too high results of 2nd step are received
    MeasurementMode["Error_Too_High_Results"] = "Error_Too_High_Results";
    // When ping step doesn't produce intermediate values
    MeasurementMode["Error_Ping_No_Intermediate_Values"] = "Error_Ping_No_Intermediate_Values";
})(MeasurementMode = exports.MeasurementMode || (exports.MeasurementMode = {}));
class SyntheticNetworkQualitySDK extends networkQuality_1.NetworkQualitySDK {
    /**
     * @param measurementMode
     * @param interval The time interval between successive emissions of NQValues in seconds.
     */
    static create(measurementMode, logger, interval = 1, dataOverride = (x) => x) {
        logger.info("SyntheticNetworkQualitySDK created.", { measurementMode, dataOverride });
        switch (measurementMode) {
            case MeasurementMode.Disabled_Benchmarks:
                return new Disabled_Benchmarks(interval, false, dataOverride);
            case MeasurementMode.Customer_NonSat_ModemAvailable:
                return new Customer_NonSat_ModemAvailable(interval, false, dataOverride);
            case MeasurementMode.Customer_NonSat_ModemAvailable_SpeedLimit:
                return new Customer_NonSat_ModemAvailable_SpeedLimit(interval, dataOverride);
            case MeasurementMode.Customer_NonSat_ModemAvailable_SwapLink:
                return new Customer_NonSat_ModemAvailable(interval, true, dataOverride);
            case MeasurementMode.Customer_NonSat_ModemNotAvailableDCA:
                return new Customer_NonSat_ModemNotAvailableDCA(interval, dataOverride);
            case MeasurementMode.Customer_NonSat_ModemFailed:
                return new Customer_NonSat_ModemFailed(interval, dataOverride);
            case MeasurementMode.Customer_Sat:
                return new Customer_Sat(interval, false, dataOverride);
            case MeasurementMode.Customer_Sat_SwapLink:
                return new Customer_Sat(interval, true, dataOverride);
            case MeasurementMode.NonCustomer_Vpn:
                return new NonCustomerSyntheticNetworkQualitySDK(true, interval, dataOverride);
            case MeasurementMode.NonCustomer_NoVpn:
                return new NonCustomerSyntheticNetworkQualitySDK(false, interval, dataOverride);
            case MeasurementMode.Wait_For_Prepare:
                return new Wait_For_Prepare(interval, dataOverride);
            case MeasurementMode.Error_Unconnected:
                return new Error_Unconnected(interval, dataOverride);
            case MeasurementMode.Error_During_Upload_NonCustomer_NoVpn:
                return new Error_During_Upload_NonCustomer_NoVpn(interval, dataOverride);
            case MeasurementMode.Error_On_Modem_Customer_NonSat_ModemAvailable:
                return new Error_On_Modem_Customer_NonSat_ModemAvailable(interval, dataOverride);
            case MeasurementMode.Error_Parallel_Speedtests:
                return new Error_Parallel_Speedtests(interval, dataOverride);
            case MeasurementMode.Error_Too_High_Results:
                return new Error_Too_High_Results(interval, dataOverride);
            case MeasurementMode.Error_Ping_No_Intermediate_Values:
                return new Error_Ping_No_Intermediate_Values(interval, dataOverride);
            case MeasurementMode.Production:
                throw new Error("");
        }
    }
    constructor(interval, dataOverride) {
        super();
        this.interval = interval;
        this.dataOverride = dataOverride;
        this.getBenchmarkValues = () => {
            return (0, immer_1.freeze)([
                (0, NQValue_1.createBenchmarkIntermediate)(100),
                (0, NQValue_1.createBenchmarkFinalAvailable)(100, 200),
            ]);
        };
        this.getDownloadValues = () => {
            return (0, immer_1.freeze)(R.range(0, 10)
                .map(i => (0, NQValue_1.createDownloadIntermediate)((90 + i) * 1e6))
                .concat([(0, NQValue_1.createDownloadFinal)(100e6, 3e6)]));
        };
        this.getUploadValues = () => {
            return (0, immer_1.freeze)(R.range(0, 10)
                .map(i => (0, NQValue_1.createUploadIntermediate)((15 + i) * 1e6))
                .concat([(0, NQValue_1.createUploadFinal)(25e6, 1e6)]));
        };
        this.getPingValues = () => {
            return (0, immer_1.freeze)(R.range(0, 10)
                .map(i => (0, NQValue_1.createPingIntermediate)((5 + i) * 1e-3))
                .concat([(0, NQValue_1.createPingFinal)(20e-3, 1e-3)]));
        };
        this.getCompleteValue = () => {
            return (0, immer_1.freeze)({ kind: NQValue_1.NQValueKind.Complete });
        };
        this.getTipValues = () => {
            return (0, immer_1.freeze)((0, NQValue_1.createHints)(R.range(1, 6)
                .map(i => {
                const hint = this.getHints().find(h => h.id === i);
                return R.isNil(hint) ? {
                    id: i,
                    title: `Hint Title #${i}`,
                    titleImageUrl: `/hint-image-url${i}.net/image.jpg`,
                    teaserTitle: `Hint Teaset Title ${i}`,
                    teaser: `Hint Teaser ${i}`,
                    teaserImageUrl: null,
                    contentTitle: null,
                    content: null,
                } : hint;
            })));
        };
        this.prepare = (options) => {
            return (0, rxjs_1.of)(this.createPrepareResult());
        };
        this.calcDownload = (data) => {
            const downloadValues = this.getDownloadValues();
            return (0, rxjs_1.of)(R.last(downloadValues));
        };
        this.calcUpload = (data) => {
            const uploadValues = this.getUploadValues();
            return (0, rxjs_1.of)(R.last(uploadValues));
        };
        this.benchmark = (prepareResult) => {
            return emitValues(this.getBenchmarkValues(), this.interval);
        };
        this.ping = (prepareResult) => {
            const retVal = this.getPingValues();
            if (retVal.length === 0) {
                return (0, rxjs_1.throwError)(() => (0, NQError_1.createNqError)("Pn-Cn-2", "Ping intermediate value list is empty"));
            }
            else {
                return emitValues(this.getPingValues(), this.interval);
            }
        };
        this.complete = (prepareResult) => {
            return (0, rxjs_1.of)(this.getCompleteValue());
        };
        this.abort = (prepareResult) => {
            return rxjs_1.EMPTY;
        };
        this.modem = (prepareResult) => {
            const modemValues = this.getModemValues();
            return emitValues(modemValues, this.interval);
        };
        this.print = (printRequestModel) => {
            const pdfFileSize = 314;
            const buf = new ArrayBuffer(pdfFileSize);
            const blob = new Blob([buf]);
            return (0, rxjs_1.of)(blob);
        };
    }
    getConfigData() {
        return (0, immer_1.freeze)({
            version: "0.8.2",
            remotePortDetectionUrl: `remotePortDetection`,
            ipDetectionUrl: {
                ipv4: `ipDetection/ipv4`,
                ipv6: `ipDetection/ipv6`,
            },
            download: {
                numStreams: 6,
                duration: 1,
                interval: 0.1,
            },
            upload: {
                duration: 1,
                interval: 0.1,
                maxBytes: 10000000,
            },
            ping: {
                duration: 1,
                interval: 0.1,
            },
            cpuBenchmark: true,
            webBenchmark: false,
            tcpRetrans: true,
            isUnderMaintenance: false,
        });
    }
    getInitData() {
        return (0, immer_1.freeze)({
            "speedtest": {
                "id": "stid123",
                "standAloneMode": false,
                "parentSpeedtestId": null,
                "clientVersion": "2.21.14",
                "startTime": "2023-09-13 19:43:15",
                "servers": {
                    "downloadServers": {
                        "dualstack": [
                            `http://localhost/download-dualstack-1`,
                            `http://localhost/download-dualstack-2`
                        ],
                        "ipv6": [
                            `http://localhost/download-ipv6-1`,
                            `http://localhost/download-ipv6-2`
                        ]
                    },
                    "uploadServer": {
                        "dualstack": `http://localhost/upload-dualstack-1`,
                        "ipv6": `http://localhost/upload-ipv6-1`
                    },
                    "pingServer": {
                        "dualstack": `http://localhost/ping-dualstack-1`,
                        "ipv6": `http://localhost/ping-ipv6-1`
                    },
                    "wsPingServer": {
                        "dualstack": "wss://speedtest-21.vodafone.anw.net/ping/",
                        "ipv6": "wss://speedtest-21v6.vodafone.anw.net/ping/"
                    },
                    "pageSpeedServer": []
                }
            },
            "connection": {
                "ip": "127.0.0.1",
                "ipVersion": openapi_1.ConnectionModelIpVersionEnum.V4,
                "remotePort": 0,
                "isp": "Vodafone GmbH",
                "isCustomer": true,
                "ispFootprint": "UM",
                "isVpnActive": false,
                "vpnDetectedBy": openapi_1.ConnectionModelVpnDetectedByEnum.Customer
            },
            "modem": {
                "name": "AVM FRITZ!Box 6660",
                "type": "6490",
                "provisionedDownloadSpeed": 115000000,
                "bookedDownloadSpeedMax": 1000000000,
                "bookedDownloadSpeedAvg": 850000000,
                "bookedDownloadSpeedMin": 600000000,
                "provisionedUploadSpeed": 56710000,
                "bookedUploadSpeedMax": 50000000,
                "bookedUploadSpeedAvg": 35000000,
                "bookedUploadSpeedMin": 15000000
            },
            "cmts": {
                "vendor": "Arris",
                "isModemTestAvailable": true
            },
            "client": {
                "id": "uuid123",
                "userAgent": null,
                "browser": {
                    "name": "TestBrowser",
                    "version": "1.1.1",
                    "isCurrent": true
                },
                "os": {
                    "name": "testOS",
                    "version": "2.2.2",
                    "isCurrent": true
                },
                "device": {
                    "deviceType": openapi_1.DeviceModelDeviceTypeEnum.Desktop
                }
            },
            "location": {
                "countryCode": "DE"
            },
            "communication": {
                "modemSwap": false,
            },
            "partialService": {
                "downloadIndex": 0,
                "uploadIndex": 0,
            }
        });
    }
    isIPv6() {
        return true;
    }
    getHints() {
        return (0, immer_1.freeze)([
            { id: 13 },
            { id: 0 },
            { id: 1 },
            { id: 2 },
            { id: 3 },
            { id: 4 },
            { id: 6 },
            { id: 7 },
            { id: 8 },
            { id: 9 },
            { id: 10 },
            { id: 11 },
            { id: 12 },
            { id: 14 },
            { id: 15 },
            { id: 16 },
            { id: 17 },
            { id: 18 },
            { id: 19 },
            { id: 20 },
            { id: 21 },
            { id: 25 },
            { id: 26 },
            { id: 30 },
            { id: 31 },
            { id: 32 },
            { id: 33 },
            { id: 34 },
            { id: 36 },
        ]);
    }
    createPrepareResult() {
        return this.dataOverride((0, NQValue_1.createPrepareResult)(this.getConfigData(), this.getInitData(), this.isIPv6()));
    }
    getSpeedtestStateValue() {
        return {
            downloadClient: true,
            uploadClient: true,
            downloadUdp: null,
        };
    }
    speedtest() {
        const self = this;
        return zipWithTimer(this.prepare().pipe(RxOp.mergeMap(prepareResult => (0, rxjs_1.concat)((0, rxjs_1.of)(prepareResult), self.benchmark(prepareResult), (0, rxjs_1.from)(self.getDownloadValues()), (0, rxjs_1.from)(self.getUploadValues()), self.ping(prepareResult), self.complete(prepareResult), self.modem(prepareResult), (0, rxjs_1.of)(this.getTipValues()))), RxOp.catchError(err => {
            return (0, rxjs_1.throwError)(() => (0, convertToNQError_1.convertToNQError)(err));
        })), this.interval);
    }
    hints(speedtestId) {
        return (0, rxjs_1.of)(this.getHints());
    }
    ;
    updateValue(key, command) {
        return (0, rxjs_1.of)(8);
    }
}
exports.SyntheticNetworkQualitySDK = SyntheticNetworkQualitySDK;
function zipWithTimer(observable, intervalSec) {
    if (intervalSec === 0) {
        return observable;
    }
    const timer = (0, rxjs_1.interval)(intervalSec * 1e3);
    return observable.pipe(RxOp.zipWith(timer), RxOp.map(v => v[0]));
}
function emitValues(values, intervalSec) {
    return zipWithTimer((0, rxjs_1.from)(values), intervalSec);
}
class Disabled_Benchmarks extends SyntheticNetworkQualitySDK {
    constructor(interval, swapLinkPresent, dataOverride) {
        super(interval, dataOverride);
        this.swapLinkPresent = swapLinkPresent;
        this.getBenchmarkValues = () => {
            return [(0, NQValue_1.createBenchmarkFinalDidNotRun)()];
        };
        this.getModemValues = () => {
            return (0, immer_1.freeze)([
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemFinalAvailable)(210e6, this.getSpeedtestStateValue(), true, openapi_1.SnmpResultModelConnectionTypeEnum.Wlan5, true, null, null),
            ]);
        };
    }
    getConfigData() {
        return (0, immer_1.produce)(super.getConfigData(), data => {
            data.cpuBenchmark = false;
        });
    }
}
class Customer_NonSat_ModemAvailable extends SyntheticNetworkQualitySDK {
    constructor(interval, swapLinkPresent, dataOverride) {
        super(interval, dataOverride);
        this.swapLinkPresent = swapLinkPresent;
        this.getModemValues = () => {
            return (0, immer_1.freeze)([
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemFinalAvailable)(210e6, this.getSpeedtestStateValue(), true, openapi_1.SnmpResultModelConnectionTypeEnum.Wlan5, true, null, null),
            ]);
        };
    }
    getInitData() {
        return (0, immer_1.produce)(super.getInitData(), data => {
            data.modem = Object.assign(Object.assign({}, data.modem), { bookedDownloadSpeedMax: 200e6, bookedDownloadSpeedAvg: 100e6, bookedDownloadSpeedMin: 50e6, bookedUploadSpeedMax: 50e6, provisionedDownloadSpeed: 202e6, provisionedUploadSpeed: 55e6, vendor: "ModemVendor", type: "ModemType-SS123" });
            if (!R.isNil(data.communication)) {
                data.communication.modemSwapLink = this.swapLinkPresent ? "http://anw.net" : null;
            }
        });
    }
}
class Error_On_Modem_Customer_NonSat_ModemAvailable extends Customer_NonSat_ModemAvailable {
    constructor(interval, dataOverride) {
        super(interval, false, dataOverride);
        this.modem = (prepareResult) => {
            return (0, rxjs_1.throwError)(() => (0, NQError_1.createNqError)("Ap-Re-5", "Server Error"));
        };
    }
    speedtest() {
        return super.speedtest().pipe(RxOp.map(v => {
            if (v.kind === NQValue_1.NQValueKind.ModemFinal) {
                throw (0, NQError_1.createNqError)("Ap-Re-5", "Server Error");
            }
            else {
                return v;
            }
        }));
    }
}
class Customer_NonSat_ModemAvailable_SpeedLimit extends SyntheticNetworkQualitySDK {
    constructor() {
        super(...arguments);
        this.modemSpeed = 210e6;
        this.getModemValues = () => {
            return (0, immer_1.freeze)([
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemFinalAvailable)(this.modemSpeed, this.getSpeedtestStateValue(), false, openapi_1.SnmpResultModelConnectionTypeEnum.Lan, true, null, null),
            ]);
        };
    }
    getInitData() {
        return (0, immer_1.produce)(super.getInitData(), data => {
            data.modem = Object.assign(Object.assign({}, data.modem), { provisionedDownloadSpeed: this.modemSpeed / 2, bookedDownloadSpeedMax: 200e6, bookedDownloadSpeedAvg: 100e6, bookedDownloadSpeedMin: 50e6, bookedUploadSpeedMax: 50e6, provisionedUploadSpeed: 55e6, vendor: "ModemVendor", type: "ModemType-SS123" });
        });
    }
}
class Customer_NonSat_ModemNotAvailableDCA extends SyntheticNetworkQualitySDK {
    constructor() {
        super(...arguments);
        this.getModemValues = () => {
            return (0, immer_1.freeze)([
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemFinalDidNotRun)(NQValue_1.ModemNotRunReason.NotAvailable, this.getSpeedtestStateValue(), null, null, null, null, null),
            ]);
        };
    }
    getInitData() {
        return (0, immer_1.produce)(super.getInitData(), data => {
            data.cmts = { isModemTestAvailable: false };
            data.modem = Object.assign(Object.assign({}, data.modem), { bookedDownloadSpeedMax: 200e6, bookedDownloadSpeedAvg: 100e6, bookedDownloadSpeedMin: 50e6, bookedUploadSpeedMax: 50e6, provisionedDownloadSpeed: 202e6, provisionedUploadSpeed: 55e6 });
        });
    }
}
class Customer_NonSat_ModemFailed extends SyntheticNetworkQualitySDK {
    constructor() {
        super(...arguments);
        this.getModemValues = () => {
            return (0, immer_1.freeze)([
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemFinalFailed)("synthetic failure", this.getSpeedtestStateValue(), null, null, null, null, null),
            ]);
        };
    }
    getInitData() {
        return (0, immer_1.produce)(super.getInitData(), data => {
            data.modem = Object.assign(Object.assign({}, data.modem), { bookedDownloadSpeedMax: 200e6, bookedDownloadSpeedAvg: 100e6, bookedDownloadSpeedMin: 50e6, bookedUploadSpeedMax: 50e6, provisionedDownloadSpeed: 202e6, provisionedUploadSpeed: 55e6 });
        });
    }
}
class Customer_Sat extends SyntheticNetworkQualitySDK {
    constructor(inverval, swapLinkPresent, dataOverride) {
        super(inverval, dataOverride);
        this.swapLinkPresent = swapLinkPresent;
        this.getModemValues = () => {
            return (0, immer_1.freeze)([
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemFinalDidNotRun)(NQValue_1.ModemNotRunReason.NotNeeded, this.getSpeedtestStateValue(), null, null, null, null, null)
            ]);
        };
    }
    getInitData() {
        return (0, immer_1.produce)(super.getInitData(), data => {
            data.modem = {
                bookedDownloadSpeedMax: 100e6,
                bookedDownloadSpeedAvg: 50e6,
                bookedDownloadSpeedMin: 25e6,
                bookedUploadSpeedMax: 25e6,
                bookedUploadSpeedAvg: 17e6,
                bookedUploadSpeedMin: 8e6,
                provisionedDownloadSpeed: 101e6,
                provisionedUploadSpeed: 27e6
            };
            if (!R.isNil(data.communication)) {
                data.communication.modemSwapLink = this.swapLinkPresent ? "http://anw.net" : null;
            }
        });
    }
}
class Wait_For_Prepare extends SyntheticNetworkQualitySDK {
    constructor(interval, dataOverride) {
        super(interval, dataOverride);
        this.prepare = (options) => {
            return (0, rxjs_1.of)(this.createPrepareResult()).pipe(RxOp.delay(this.interval));
        };
        this.getModemValues = () => {
            return (0, immer_1.freeze)([
                (0, NQValue_1.createModemFinalDidNotRun)(NQValue_1.ModemNotRunReason.NotACustomer, this.getSpeedtestStateValue(), null, null, null, null, null)
            ]);
        };
    }
}
class NonCustomerSyntheticNetworkQualitySDK extends SyntheticNetworkQualitySDK {
    constructor(isVpn, interval, dataOverride) {
        super(interval, dataOverride);
        this.isVpn = isVpn;
        this.getModemValues = () => {
            return (0, immer_1.freeze)([
                (0, NQValue_1.createModemFinalDidNotRun)(NQValue_1.ModemNotRunReason.NotACustomer, this.getSpeedtestStateValue(), null, null, null, null, null)
            ]);
        };
    }
    getInitData() {
        return (0, immer_1.produce)(super.getInitData(), data => {
            data.modem = {};
            data.connection.remotePort = null;
            data.connection.isCustomer = false;
            data.connection.ispFootprint = undefined;
            data.connection.isVpnActive = this.isVpn;
        });
    }
}
class Error_During_Upload_NonCustomer_NoVpn extends NonCustomerSyntheticNetworkQualitySDK {
    constructor(interval, dataOverride) {
        super(false, interval, dataOverride);
    }
    speedtest() {
        return super.speedtest().pipe(RxOp.map(v => {
            if (v.kind === NQValue_1.NQValueKind.UploadFinal) {
                throw (0, NQError_1.createNqError)("Up-Cn-2", "Server Error");
            }
            else {
                return v;
            }
        }));
    }
}
class Error_Unconnected extends SyntheticNetworkQualitySDK {
    constructor(interval, dataOverride) {
        super(interval, dataOverride);
        this.prepare = (options) => {
            return (0, rxjs_1.throwError)(() => (0, NQError_1.createNqError)("Ap-Cn-1", "Connectivity Error"));
        };
        this.calcDownload = (data) => {
            return (0, rxjs_1.throwError)(() => (0, NQError_1.createNqError)("Ap-Cn-1", "Connectivity Error"));
        };
        this.calcUpload = (data) => {
            return (0, rxjs_1.throwError)(() => (0, NQError_1.createNqError)("Ap-Cn-1", "Connectivity Error"));
        };
        this.ping = (prepareResult) => {
            return (0, rxjs_1.throwError)(() => (0, NQError_1.createNqError)("Ap-Cn-1", "Connectivity Error"));
        };
        this.complete = (prepareResult) => {
            return (0, rxjs_1.throwError)(() => (0, NQError_1.createNqError)("Ap-Cn-1", "Connectivity Error"));
        };
        this.abort = (prepareResult) => {
            return (0, rxjs_1.throwError)(() => (0, NQError_1.createNqError)("Ap-Cn-1", "Connectivity Error"));
        };
        this.modem = (prepareResult) => {
            return (0, rxjs_1.throwError)(() => (0, NQError_1.createNqError)("Ap-Cn-1", "Connectivity Error"));
        };
    }
    getModemValues() {
        return [];
    }
    speedtest() {
        return (0, rxjs_1.from)([1]).pipe(RxOp.delay(this.interval), RxOp.map(_ => {
            throw (0, NQError_1.createNqError)("Ap-Cn-1", "Connectivity Error");
        }));
    }
}
class Error_Parallel_Speedtests extends Customer_NonSat_ModemNotAvailableDCA {
    constructor(interval, dataOverride) {
        super(interval, dataOverride);
        this.prepare = (options) => {
            return (0, rxjs_1.throwError)(() => (0, NQError_1.createNqError)("Ps-1", "Parallel Speedtest"));
        };
    }
    speedtest() {
        return super.speedtest().pipe(RxOp.map(v => {
            if (v.kind === NQValue_1.NQValueKind.PrepareResult) {
                throw (0, NQError_1.createNqError)("Ps-1", "Parallel Speedtest");
            }
            else {
                return v;
            }
        }));
    }
}
class Error_Too_High_Results extends SyntheticNetworkQualitySDK {
    constructor(interval, dataOverride) {
        super(interval, dataOverride);
        this.getModemValues = () => {
            return (0, immer_1.freeze)([
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemIntermediateExecuting)(),
                (0, NQValue_1.createModemFinalFailed)("Too high result (synthetic failure)", this.getSpeedtestStateValue(), null, null, null, null, null),
            ]);
        };
    }
    getInitData() {
        const bookedDownloadSpeedMax = 200e6;
        return (0, immer_1.produce)(super.getInitData(), data => {
            data.modem = {
                bookedDownloadSpeedMax: bookedDownloadSpeedMax,
                bookedUploadSpeedMax: 50e6,
                provisionedDownloadSpeed: bookedDownloadSpeedMax * 1.1,
                provisionedUploadSpeed: 55e6,
                vendor: "ModemVendor",
                type: "ModemType-SS123",
            };
        });
    }
}
class Error_Ping_No_Intermediate_Values extends SyntheticNetworkQualitySDK {
    constructor(interval, dataOverride) {
        super(interval, dataOverride);
        this.getPingValues = () => {
            return [];
        };
        this.getModemValues = () => {
            return (0, immer_1.freeze)([
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemIntermediateResolving)(),
                (0, NQValue_1.createModemFinalDidNotRun)(NQValue_1.ModemNotRunReason.NotAvailable, this.getSpeedtestStateValue(), null, null, null, null, null),
            ]);
        };
    }
}
//# sourceMappingURL=syntheticNetworkQuality.js.map